module.exports = __webpack_public_path__ + "img/room_mr.b8a9fa06.png";